import React, { useState } from "react";
import bannerImg from "../assets/images/quote.jpg";
import {
  CustomCalenderInput,
  CustomDropDown,
  CustomInput,
  CustomTextArea,
} from "../components/Input/input";
import { Button } from "primereact/button";

export default function RequestQuote() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => null;
  return (
    <div>
      <img alt="Request a Quote" src={bannerImg} className="responsive" />
      <div className="flex justify-content-center p-3">
        <div className="col-12 md:col-8 p-3 border-round-xl shadow-3 ">
          <h2 className="text-center">Request a Quote</h2>
          <small className="pl-2">Company Information</small>
          <form onSubmit={handleSubmit} className="mt-5">
            <div className="flex flex-wrap">
              <CustomInput
                label="First Name"
                name="firstName"
                value={data?.first_name || ""}
                onChange={handleChange}
              />
              <CustomInput
                label="Last Name"
                name="lastName"
                value={data?.lastName || ""}
                onChange={handleChange}
              />
              <CustomInput
                label="Company Name"
                name="companyName"
                value={data?.companyName || ""}
                onChange={handleChange}
                col={12}
              />
              <CustomInput
                label="Email"
                name="email"
                value={data?.email || ""}
                onChange={handleChange}
              />
              <CustomInput
                label="Phone Number"
                name="phone"
                value={data?.phone || ""}
                onChange={handleChange}
              />
              <CustomInput
                label="Address"
                col={12}
                onChange={handleChange}
                name="address"
                value={data?.address || ""}
              />
              <CustomDropDown
                options={[
                  { value: "Canada" },
                  { value: "USA" },
                  { value: "Mexico" },
                ]}
                label="Country"
                optionLabel="value"
                col={6}
                onChange={handleChange}
                name="country"
                value={data?.country}
              />
              <CustomInput
                label="Province"
                onChange={handleChange}
                name="province"
                value={data?.province || ""}
              />
              <CustomInput
                label="City"
                onChange={handleChange}
                name="city"
                value={data?.city || ""}
              />
              <CustomInput
                label="Zipcode"
                onChange={handleChange}
                name="zipcode"
                value={data?.zipcode || ""}
              />
              <small className="pl-2 my-3">Shipping Information</small>
              <CustomInput
                label="Commodity"
                onChange={handleChange}
                name="commodity"
                col={12}
                value={data?.commodity || ""}
              />
              <CustomInput
                label="Pickup Location"
                onChange={handleChange}
                name="pickupLocation"
                value={data?.pickupLocation || ""}
              />
              <CustomCalenderInput
                label="Pickup Date"
                onChange={handleChange}
                name="pickupDate"
                value={data?.pickupDate}
              />
              <CustomInput
                label="Delivery  Location"
                onChange={handleChange}
                name="deliveryLocation"
                value={data?.deliveryLocation || ""}
              />
              <CustomCalenderInput
                label="Delivery  Date"
                onChange={handleChange}
                name="deliveryDate"
                value={data?.deliveryDate}
              />
              <CustomTextArea
                label="Your Message"
                name="message"
                value={data?.message || ""}
                onChange={handleChange}
              />
              <Button
                label={loading ? "Submitting..." : "Submit"}
                severity="secondary"
                className="mt-4 mx-2"
                type="submit"
                disabled={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
